
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Head, Header, Steps } from 'mdx-deck';
import { CodeSurfer } from 'code-surfer';
import { nightOwl } from '@code-surfer/themes';
import { FootNote } from './components/FootNote';
import { Logo } from './components/Logo';
import { Link } from './components/Link';
import { theme as myTheme } from './theme';
import SSRDiagram from './static/ssr-diagram.png';
import ClientSideRenderingDiagram from './static/client-side-rendering-diagram.png';
import AndroidJqueryReact from './static/android-jquery-react.png';
import Craiglist from './static/craiglist.png';
import Twitter from './static/twitter.png';
import ReactNPMStats from './static/react-npm-stats.png';
import ReactGitHubStats from './static/react-github-stats.png';
import ReactChromeStats from './static/react-chrome-stats.png';
import SheetImperative from './static/sheet-imperative.gif';
import SheetDeclarative from './static/sheet-declarative.gif';
import ComponentsTree from './static/components-tree.png';
import ReactPlatforms from './static/react-platforms.png';
import LegoBricks from './static/lego-bricks.png';
import LegoComponentsGood from './static/lego-components-good.jpeg';
import LegoComponentsBad from './static/lego-components-bad.jpeg';
import CreateReactApp from './static/create-react-app.png';
import ReactDevTools from './static/react-dev-tools.png';
import ReactDevToolsComponentsTree from './static/react-dev-tools-components-tree.png';
import ReactDevToolsFlamegraph from './static/react-dev-tools-flamegraph.png';
import Netlify00 from './static/netlify-00.png';
import Netlify01 from './static/netlify-01.png';
import Netlify02 from './static/netlify-02.png';
import Netlify03 from './static/netlify-03.png';
import Netlify04 from './static/netlify-04.png';
import Netlify05 from './static/netlify-05.png';
export const theme = myTheme;
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Head mdxType="Head">
  <title>🚀 Introduction à React.js — @greeeg</title>
    </Head>
    <Header mdxType="Header">
  <Logo mdxType="Logo" />
    </Header>
    <h1>{`Introduction à React.js`}</h1>
    <p>{`HETIC P2023`}</p>
    <hr></hr>
    <h1>{`Hello 💂‍♂️`}</h1>
    <hr></hr>
    <h1>{`Grégoire Mielle`}</h1>
    <ul>
      <li parentName="ul">{`📣 Twitter: `}<a parentName="li" {...{
          "href": "https://twitter.com/greeeg"
        }}>{`@greeeg`}</a></li>
      <li parentName="ul">{`🔬 GitHub: `}<a parentName="li" {...{
          "href": "https://github.com/greeeg"
        }}>{`@greeeg`}</a></li>
      <li parentName="ul">{`✏️ Email: `}<a parentName="li" {...{
          "href": "mailto:hello@greeeg.com"
        }}>{`hello@greeeg.com`}</a></li>
    </ul>
    <hr></hr>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`👨‍💻 Étudiant en H5`}</li>
        <li parentName="ul">{`👨‍🚀 Software Engineer `}<a parentName="li" {...{
            "href": "https://payfit.com/en/"
          }}>{`@PayFit`}</a></li>
        <li parentName="ul">{`💸 Freelance`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Une expertise pour tout le monde`}</li>
        <li parentName="ul">{`Une compétence pour vos futurs projets & stages`}</li>
        <li parentName="ul">{`Si vous êtes perdu, dites-le`}</li>
        <li parentName="ul">{`Challengez-moi !`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`Un peu d'histoire...`}</h1>
    <p>{`Comment fonctionne l'affichage d'une page web ?`}</p>
    <hr></hr>

    <img src={SSRDiagram} style={{
      width: 'auto',
      height: '70vh'
    }} />
    <FootNote mdxType="FootNote">
  📚{' '}
  <a href="https://www.freecodecamp.org/news/how-the-web-works-a-primer-for-newcomers-to-web-development-or-anyone-really-b4584e63585c/">
    Comment le web fonctionne ?
  </a>
    </FootNote>
    <hr></hr>

    <img src={ClientSideRenderingDiagram} style={{
      width: 'auto',
      height: '70vh'
    }} />
    <hr></hr>

    <img src={AndroidJqueryReact} style={{
      width: '60vw',
      height: 'auto',
      marginBottom: 40
    }} />
    <p>{`Quel est le lien entre toutes ces technologies ?`}</p>
    <hr></hr>
    <h1>{`Technologies client-side`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Interfaces plus complexes`}</li>
        <li parentName="ul">{`Beaucoup plus d'interactions`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`Les besoins côté utilisateur ont évolué`}</h1>
    <ul>
      <li parentName="ul">{`Expérience mobile (3G, offline, etc.)`}</li>
      <li parentName="ul">{`Sources de données nombreuses`}</li>
    </ul>
    <FootNote mdxType="FootNote">
  📚 <a href="https://web.dev/">Le futur du web avec Google - Web.dev</a>
    </FootNote>
    <hr></hr>

    <img src={Craiglist} style={{
      height: '60vh',
      width: 'auto'
    }} />
    <hr></hr>

    <img src={Twitter} style={{
      height: '60vh',
      width: 'auto'
    }} />
    <hr></hr>
    <h1>{`De nouvelles solutions ont émergé`}</h1>
    <ul>
      <li parentName="ul">{`Jquery (2006)`}</li>
      <li parentName="ul">{`Angular.js (2009)`}</li>
      <li parentName="ul">{`Backbone.js (2010)`}</li>
      <li parentName="ul">{`Ember.js (2011)`}</li>
      <li parentName="ul">{`React.js (2013)`}</li>
      <li parentName="ul">{`Vue.js (2014)`}</li>
    </ul>
    <hr></hr>
    <h1>{`🤔`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Comment bien les choisir ?`}</li>
        <li parentName="ul">{`Quelles différences/ressemblances ?`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`📚 `}<a parentName="h1" {...{
        "href": "https://2019.stateofjs.com/"
      }}>{`State of JS - 2019 Edition`}</a></h1>
    <hr></hr>

    <img src={ReactNPMStats} style={{
      height: '50vh',
      width: 'auto'
    }} />
    <hr></hr>

    <img src={ReactGitHubStats} style={{
      width: '80vw',
      height: 'auto'
    }} />
    <hr></hr>

    <img src={ReactChromeStats} style={{
      width: '60vw',
      height: 'auto'
    }} />
    <hr></hr>
    <h1>{`React.js`}</h1>
    <p>{`A JavaScript library for building user interfaces`}</p>
    <hr></hr>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Declarative`}</li>
        <li parentName="ul">{`Component-Based`}</li>
        <li parentName="ul">{`Learn Once, Write Anywhere`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`Declarative vs Imperative`}</h1>
    <p><strong parentName="p">{`Dessine un chat.`}</strong>{` vs `}<strong parentName="p">{`Fais un trait noir, puis un arrondi vers le bas, etc.`}</strong></p>
    <FootNote mdxType="FootNote">
  📚{' '}
  <a href="https://codeburst.io/declarative-vs-imperative-programming-a8a7c93d9ad2">
    Declarative vs Imperative programming
  </a>
    </FootNote>
    <hr></hr>

    <h1>{`Imperative`}</h1>
    <img src={SheetImperative} style={{
      width: '50vw',
      height: 'auto',
      marginBottom: 50
    }} />
    <p>{`On doit effectuer un calcul à chaque modification d'une des 2 variables qui définissent "fullname"`}</p>
    <hr></hr>

    <h1>{`Declarative`}</h1>
    <img src={SheetDeclarative} style={{
      width: '50vw',
      height: 'auto',
      marginBottom: 50
    }} />
    <p>{`On déclare comment "fullname" est défini sans jamais le modifier manuellement`}</p>
    <hr></hr>

    <h1>{`Component-based`}</h1>
    <img src={ComponentsTree} style={{
      width: 'auto',
      height: '40vh'
    }} />
    <FootNote mdxType="FootNote">
  📚{' '}
  <a href="https://itnext.io/a-guide-to-component-driven-development-cdd-1516f65d8b55">
    A Guide to Component Driven Development
  </a>
    </FootNote>
    <hr></hr>

    <h1>{`Learn Once, Write Anywhere`}</h1>
    <img src={ReactPlatforms} style={{
      width: '60vw',
      height: 'auto'
    }} />
    <FootNote mdxType="FootNote">
  📚{' '}
  <a href="https://reactpodcast.simplecast.fm/81">
    React Podcast: Evan Bacon on Expo and the Future of "Build Once; Run
    Anywhere"
  </a>
    </FootNote>
    <hr></hr>
    <h1>{`Qui l'utilise ?`}</h1>
    <ul>
      <li parentName="ul">{`Facebook (FB.com, WhatsApp, Instagram)`}</li>
      <li parentName="ul">{`American Express`}</li>
      <li parentName="ul">{`Apple`}</li>
      <li parentName="ul">{`Baidu`}</li>
      <li parentName="ul">{`Netflix`}</li>
      <li parentName="ul">{`Uber`}</li>
    </ul>
    <hr></hr>
    <h1>{`Qui l'utilise ?`}</h1>
    <ul>
      <li parentName="ul">{`Skype`}</li>
      <li parentName="ul">{`Tesla`}</li>
      <li parentName="ul">{`Slack`}</li>
      <li parentName="ul">{`Discord`}</li>
      <li parentName="ul">{`Walmart`}</li>
      <li parentName="ul">{`Pinterest`}</li>
    </ul>
    <hr></hr>
    <h1>{`Qui l'utilise ?`}</h1>
    <ul>
      <li parentName="ul">{`Twitter`}</li>
      <li parentName="ul">{`PayPal`}</li>
      <li parentName="ul">{`Tinder`}</li>
      <li parentName="ul">{`AirBnB`}</li>
      <li parentName="ul">{`Dropbox`}</li>
      <li parentName="ul">{`PayFit`}</li>
    </ul>
    <hr></hr>
    <h2>{`Les bases de React.js`}</h2>
    <Link step={38} mdxType="Link">Le JSX</Link>
    <Link step={44} mdxType="Link">Les composants</Link>
    <Link step={50} mdxType="Link">Les props</Link>
    <Link step={56} mdxType="Link">Le style</Link>
    <Link step={67} mdxType="Link">Gestion des évènements</Link>
    <hr></hr>
    <Link step={71} mdxType="Link">Le state</Link>
    <Link step={79} mdxType="Link">Le cycle de vie</Link>
    <Link step={88} mdxType="Link">Le rendu conditionnel</Link>
    <Link step={91} mdxType="Link">Les listes</Link>
    <Link step={93} mdxType="Link">Les formulaires</Link>
    <hr></hr>
    <h1>{`Hello World 🚀`}</h1>
    <hr></hr>
    <h1>{`Comment crée-t-on un élément du DOM en Javascript ?`}</h1>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "subtitle=\"On récupère une référence de notre parent\"",
          "subtitle": "\"On",
          "récupère": true,
          "une": true,
          "référence": true,
          "de": true,
          "notre": true,
          "parent\"": true
        }}>{`<body>
  <div id="root"></div>

  <script type="text/javascript">
    function addHelloWorld() {
      const root = document.querySelector('#root');
    }
  </script>
</body>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "subtitle=\"On crée un élément\"",
          "subtitle": "\"On",
          "crée": true,
          "un": true,
          "élément\"": true
        }}>{`<body>
  <div id="root"></div>

  <script type="text/javascript">
    function addHelloWorld() {
      const root = document.querySelector('#root');
      const element = document.createElement('div');
      element.textContent = 'Hello World';
      element.className = 'container';
    }
  </script>
</body>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "1:13 subtitle=\"On l'ajoute dans le parent\"",
          "1:13": true,
          "subtitle": "\"On",
          "l'ajoute": true,
          "dans": true,
          "le": true,
          "parent\"": true
        }}>{`<body>
  <div id="root"></div>

  <script type="text/javascript">
    function addHelloWorld() {
      const root = document.querySelector('#root');
      const element = document.createElement('div');
      element.textContent = 'Hello World';
      element.className = 'container';
      root.appendChild(element);
    }
  </script>
</body>
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Avec React.js`}</h1>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "subtitle=\"On importe deux packages/librairies\"",
          "subtitle": "\"On",
          "importe": true,
          "deux": true,
          "packages/librairies\"": true
        }}>{`<body>
  <div id="root"></div>

  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script type="text/javascript"></script>
</body>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "subtitle=\"On récupère une référence de notre parent\"",
          "subtitle": "\"On",
          "récupère": true,
          "une": true,
          "référence": true,
          "de": true,
          "notre": true,
          "parent\"": true
        }}>{`<body>
  <div id="root"></div>

  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script type="text/javascript">
    function addHelloWorld() {
      const root = document.getElementById('root');
    }
  </script>
</body>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "subtitle=\"On crée notre élément\"",
          "subtitle": "\"On",
          "crée": true,
          "notre": true,
          "élément\"": true
        }}>{`<body>
  <div id="root"></div>

  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script type="text/javascript">
    function addHelloWorld() {
      const root = document.getElementById('root');
      const element = React.createElement('div', {
        className: 'container',
        children: 'Hello World'
      });
    }
  </script>
</body>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "subtitle=\"On l'ajoute dans le parent\"",
          "subtitle": "\"On",
          "l'ajoute": true,
          "dans": true,
          "le": true,
          "parent\"": true
        }}>{`<body>
  <div id="root"></div>

  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script type="text/javascript">
    function addHelloWorld() {
      const root = document.getElementById('root');
      const element = React.createElement('div', {
        className: 'container',
        children: 'Hello World'
      });
      ReactDOM.render(element, root);
    }
  </script>
</body>
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Pour utiliser React.js on a donc besoin de 2 packages`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><strong parentName="li">{`React`}</strong>{`: Les fonctionnalités permettant de définir des composants React`}</li>
        <li parentName="ul"><strong parentName="li">{`React DOM`}</strong>{`: Un moteur de rendu pour le web`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-html"
        }}>{`<body>
  <div id="root"></div>

  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script type="text/javascript">
    function addHelloWorld() {
      const root = document.getElementById('root');
      const element = React.createElement('div', {
        className: 'container',
        children: 'Hello World'
      });
      ReactDOM.render(element, root);
    }
  </script>
</body>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "subtitle=\"Du HTML dans du Javascript 🤔\"",
          "subtitle": "\"Du",
          "HTML": true,
          "dans": true,
          "du": true,
          "Javascript": true,
          "🤔\"": true
        }}>{`<body>
  <div id="root"></div>

  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script src="https://unpkg.com/@babel/standalone@7.8.3/babel.js"></script>
  <script type="text/babel">
    function addHelloWorld() {
      const root = document.getElementById('root');
      const element = <div className="container">Hello World</div>;
      ReactDOM.render(element, root);
    }
  </script>
</body>
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Le JSX`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Une extension syntaxique au Javascript`}</li>
        <li parentName="ul">{`Transpilé par `}<a parentName="li" {...{
            "href": "https://babeljs.io/en/repl#?browsers=&build=&builtIns=false&spec=false&loose=false&code_lz=MYewdgzgLgBApgGzgWzmWBeGAeAJgSwDcZgEBDCCAOTNQwCJR0z8w4AnegPgAlEEQMAOoh2CXNgD0BQlyA&debug=false&forceAllTransforms=false&shippedProposals=false&circleciRepo=&evaluate=false&fileSize=false&timeTravel=false&sourceType=module&lineWrap=true&presets=es2015%2Creact%2Cstage-2&prettier=false&targets=&version=7.8.7&externalPlugins="
          }}>{`Babel`}</a>{` en Javascript`}</li>
      </ul>
    </Steps>
    <FootNote mdxType="FootNote">
  📚 <a href="https://jasonformat.com/wtf-is-jsx/">WTF is JSX?</a>
    </FootNote>
    <hr></hr>
    <h1>{`Pourquoi le JSX ?`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Permet de définir des arbres de composants simplement`}</li>
        <li parentName="ul">{`S'appuie sur une syntaxe familière (le HTML)`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`⚠️ Pour utiliser du `}<strong parentName="h2">{`JSX`}</strong>{`, on doit avoir Babel configuré sur son projet`}</h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Si la variable ne contient qu'un élément, on l'écrit comme ça\"",
          "subtitle": "\"Si",
          "la": true,
          "variable": true,
          "ne": true,
          "contient": true,
          "qu'un": true,
          "élément,": true,
          "on": true,
          "l'écrit": true,
          "comme": true,
          "ça\"": true
        }}>{`const message = <p>Hello World</p>;
ReactDOM.render(message, document.getElementById('root'));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Si la variable contient des éléments imbriqués, on l'écrit comme ça\"",
          "subtitle": "\"Si",
          "la": true,
          "variable": true,
          "contient": true,
          "des": true,
          "éléments": true,
          "imbriqués,": true,
          "on": true,
          "l'écrit": true,
          "comme": true,
          "ça\"": true
        }}>{`const message = (
  <div>
    <p>Hello World</p>
  </div>
);
ReactDOM.render(message, document.getElementById('root'));
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`Embedded expressions`}</h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"En Javascript, on peut utiliser les template strings pour intégrer des expressions dans une chaîne de caractères\"",
          "subtitle": "\"En",
          "Javascript,": true,
          "on": true,
          "peut": true,
          "utiliser": true,
          "les": true,
          "template": true,
          "strings": true,
          "pour": true,
          "intégrer": true,
          "des": true,
          "expressions": true,
          "dans": true,
          "une": true,
          "chaîne": true,
          "de": true,
          "caractères\"": true
        }}>{`const price = 12.5;
const tva = 19.6;
const total = price + price * (tva / 100);

const message = \`The price with included taxes is \${total} euros.\`;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On peut même directement appeler des fonctions\"",
          "subtitle": "\"On",
          "peut": true,
          "même": true,
          "directement": true,
          "appeler": true,
          "des": true,
          "fonctions\"": true
        }}>{`const price = 12.5;
const tva = 19.6;
const total = price + price * (tva / 100);

const message = \`The price with included taxes is \${parseInt(total)} euros.\`;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"En JSX, on peut faire la même chose en omettant le $\"",
          "subtitle": "\"En",
          "JSX,": true,
          "on": true,
          "peut": true,
          "faire": true,
          "la": true,
          "même": true,
          "chose": true,
          "en": true,
          "omettant": true,
          "le": true,
          "$\"": true
        }}>{`const price = 12.5;
const tva = 19.6;
const total = price + price * (tva / 100);

const message = <p>The price with included taxes is {total} euros.</p>;
ReactDOM.render(message, document.getElementById('root'));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Et aussi appeler des fonctions dans le JSX\"",
          "subtitle": "\"Et",
          "aussi": true,
          "appeler": true,
          "des": true,
          "fonctions": true,
          "dans": true,
          "le": true,
          "JSX\"": true
        }}>{`const price = 12.5;
const tva = 19.6;
const total = price + price * (tva / 100);

const message = (
  <p>The price with included taxes is {parseInt(total)} euros.</p>
);
ReactDOM.render(message, document.getElementById('root'));
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Les composants React.js`}</h1>
    <hr></hr>
    <h2>{`On définit un composant comme étant un élément/objet qui entre dans la composition de quelque chose`}</h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Imaginons une application de cartes d'anniversaire\"",
          "subtitle": "\"Imaginons",
          "une": true,
          "application": true,
          "de": true,
          "cartes": true,
          "d'anniversaire\"": true
        }}>{`const julia = 'Julia Robert';

const wishMessageJulia = \`HAPPY BIRTHDAY \${julia.toUpperCase()}!\`;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Dans laquelle on génère des messages d'anniversaire\"",
          "subtitle": "\"Dans",
          "laquelle": true,
          "on": true,
          "génère": true,
          "des": true,
          "messages": true,
          "d'anniversaire\"": true
        }}>{`const julia = 'Julia Robert';
const thomas = 'Thomas René';

const wishMessageJulia = \`HAPPY BIRTHDAY \${julia.toUpperCase()}!\`;
const wishMessageThomas = \`HAPPY BIRTHDAY \${thomas.toUpperCase()}!\`;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Pour simplifier la tâche, on crée une fonction qui génère les messages\"",
          "subtitle": "\"Pour",
          "simplifier": true,
          "la": true,
          "tâche,": true,
          "on": true,
          "crée": true,
          "une": true,
          "fonction": true,
          "qui": true,
          "génère": true,
          "les": true,
          "messages\"": true
        }}>{`const julia = 'Julia Robert';
const thomas = 'Thomas René';

function wishHappyBirthday(name) {
  return \`HAPPY BIRTHDAY \${name.toUpperCase()}!\`;
}

const wishMessageJulia = wishHappyBirthday(julia);
const wishMessageThomas = wishHappyBirthday(thomas);
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Si on souhaitait réaliser cette application avec React.js, on créerait sûrement les éléments suivants\"",
          "subtitle": "\"Si",
          "on": true,
          "souhaitait": true,
          "réaliser": true,
          "cette": true,
          "application": true,
          "avec": true,
          "React.js,": true,
          "créerait": true,
          "sûrement": true,
          "les": true,
          "éléments": true,
          "suivants\"": true
        }}>{`const julia = 'Julia Robert';
const thomas = 'Thomas René';

const wishMessageJulia = <p>HAPPY BIRTHDAY {julia.toUpperCase()}!</p>;
const wishMessageThomas = <p>HAPPY BIRTHDAY {thomas.toUpperCase()}!</p>;

const app = (
  <div>
    {wishMessageJulia}
    {wishMessageThomas}
  </div>
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On peut, comme en Javascript, créer une fonction qui génère ces messages\"",
          "subtitle": "\"On",
          "peut,": true,
          "comme": true,
          "en": true,
          "Javascript,": true,
          "créer": true,
          "une": true,
          "fonction": true,
          "qui": true,
          "génère": true,
          "ces": true,
          "messages\"": true
        }}>{`const julia = 'Julia Robert';
const thomas = 'Thomas René';

function WishHappyBirthday() {
  return <p>HAPPY BIRTHDAY!</p>;
}
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`Les composants React.js`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Des fonctions qui retournent des éléments React.js`}</li>
        <li parentName="ul">{`Ou d'autres composants (fonctions) qu'on a créé`}</li>
        <li parentName="ul">{`Des briques d'interface réutilisables`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"⛔️ Pour utiliser ces composants, on ne les appelle pas comme des fonctions Javascript\"",
          "subtitle": "\"⛔️",
          "Pour": true,
          "utiliser": true,
          "ces": true,
          "composants,": true,
          "on": true,
          "ne": true,
          "les": true,
          "appelle": true,
          "pas": true,
          "comme": true,
          "des": true,
          "fonctions": true,
          "Javascript\"": true
        }}>{`function WishHappyBirthday() {
  return <p>HAPPY BIRTHDAY!</p>;
}

const app = (
  <div>
    {WishHappyBirthday()}
    {WishHappyBirthday()}
  </div>
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"✅ Mais comme ceci\"",
          "subtitle": "\"✅",
          "Mais": true,
          "comme": true,
          "ceci\"": true
        }}>{`function WishHappyBirthday() {
  return <p>HAPPY BIRTHDAY!</p>;
}

const app = (
  <div>
    <WishHappyBirthday />
    <WishHappyBirthday />
  </div>
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Cela permet de les différencier des éléments natifs en JSX\"",
          "subtitle": "\"Cela",
          "permet": true,
          "de": true,
          "les": true,
          "différencier": true,
          "des": true,
          "éléments": true,
          "natifs": true,
          "en": true,
          "JSX\"": true
        }}>{`function WishHappyBirthday() {
  return <p>HAPPY BIRTHDAY!</p>;
}

const app = (
  <div>
    <WishHappyBirthday />
    <a href="/index.html">Link to home</a>
    <WishHappyBirthday />
  </div>
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On peut aussi les écrire comme ceci\"",
          "subtitle": "\"On",
          "peut": true,
          "aussi": true,
          "les": true,
          "écrire": true,
          "comme": true,
          "ceci\"": true
        }}>{`const WishHappyBirthday = () => {
  return <p>HAPPY BIRTHDAY!</p>;
};

const app = (
  <div>
    <WishHappyBirthday />
    <a href="/index.html">Link to home</a>
    <WishHappyBirthday />
  </div>
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On encore comme ceci\"",
          "subtitle": "\"On",
          "encore": true,
          "comme": true,
          "ceci\"": true
        }}>{`const WishHappyBirthday = () => <p>HAPPY BIRTHDAY!</p>;

const app = (
  <div>
    <WishHappyBirthday />
    <a href="/index.html">Link to home</a>
    <WishHappyBirthday />
  </div>
);
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Les props`}</h1>
    <hr></hr>
    <h2>{`Les props sont des paramètres/arguments passés aux composants React.js pour :`}</h2>
    <Steps mdxType="Steps">
      <ol>
        <li parentName="ol">{`afficher quelque chose de dynamique`}</li>
        <li parentName="ol">{`pour faire du rendu conditionnel`}</li>
        <li parentName="ol">{`pour passer ce même paramètre a un composant enfant`}</li>
      </ol>
    </Steps>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Sans props, impossible de rendre dynamique ce que mon composant affiche\"",
          "subtitle": "\"Sans",
          "props,": true,
          "impossible": true,
          "de": true,
          "rendre": true,
          "dynamique": true,
          "ce": true,
          "que": true,
          "mon": true,
          "composant": true,
          "affiche\"": true
        }}>{`function WishHappyBirthday() {
  return <p>HAPPY BIRTHDAY!</p>;
}

const App = () => <WishHappyBirthday />;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Ici, on passe une prop qui est utilisée dans le JSX\"",
          "subtitle": "\"Ici,",
          "on": true,
          "passe": true,
          "une": true,
          "prop": true,
          "qui": true,
          "est": true,
          "utilisée": true,
          "dans": true,
          "le": true,
          "JSX\"": true
        }}>{`function WishHappyBirthday(props) {
  return <p>HAPPY BIRTHDAY {props.name.toUpperCase()}!</p>;
}

const App = () => <WishHappyBirthday name="Julia" />;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On peut simplifer l'écriture en destructurant l'objet props\"",
          "subtitle": "\"On",
          "peut": true,
          "simplifer": true,
          "l'écriture": true,
          "en": true,
          "destructurant": true,
          "l'objet": true,
          "props\"": true
        }}>{`function WishHappyBirthday({ name }) {
  return <p>HAPPY BIRTHDAY {name.toUpperCase()}!</p>;
}

const App = () => <WishHappyBirthday name="Julia" />;
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`En résumé`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><strong parentName="li">{`React.js`}</strong>{` est une librairie pour construire des interfaces`}</li>
        <li parentName="ul">{`créées à partir de `}<strong parentName="li">{`briques réutilisables`}</strong>{` (components)`}</li>
        <li parentName="ul">{`qui utilise une extension syntaxique appelée le `}<strong parentName="li">{`JSX`}</strong></li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`En résumé`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`elle s'appuie sur 2 packages (`}<strong parentName="li"><inlineCode parentName="strong">{`react`}</inlineCode></strong>{` & `}<strong parentName="li"><inlineCode parentName="strong">{`react-dom`}</inlineCode></strong>{`)`}</li>
        <li parentName="ul">{`mais peut aussi être utilisée ailleurs (native, VR, etc.)`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Attention à ne pas confondre composants et éléments\"",
          "subtitle": "\"Attention",
          "à": true,
          "ne": true,
          "pas": true,
          "confondre": true,
          "composants": true,
          "et": true,
          "éléments\"": true
        }}>{`const element = (
  <a href="https://google.com" title="Google">
    Search on Google
  </a>
);

function Component() {
  return (
    <a href="https://google.com" title="Google">
      Search on Google
    </a>
  );
}

const App = () => (
  <div>
    {element}
    <Component />
  </div>
);
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Le style en React.js`}</h1>
    <hr></hr>
    <h2>{`Il existe trois manières de styliser des applications React`}</h2>
    <hr></hr>
    <h1>{`En utilisant du CSS classique`}</h1>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-html"
        }}>{`<body>
  <div id="root"></div>
  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script src="https://unpkg.com/@babel/standalone@7.8.3/babel.js"></script>
  <style>
    .box {
      border: 1px solid #333;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }
    .box--large {
      width: 270px;
      height: 270px;
    }
  </style>
  <script type="text/babel">
    const Box = ({ children }) => {
      return <div className="box box--large">{children}</div>;
    };

    const element = (
      <div>
        <Box>small lightblue box</Box>
      </div>
    );

    ReactDOM.render(element, document.getElementById('root'));
  </script>
</body>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "7:17",
          "7:17": true
        }}>{`<body>
  <div id="root"></div>
  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script src="https://unpkg.com/@babel/standalone@7.8.3/babel.js"></script>
  <style>
    .box {
      border: 1px solid #333;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }
    .box--large {
      width: 270px;
      height: 270px;
    }
  </style>
  <script type="text/babel">
    const Box = ({ children }) => {
      return <div className="box box--large">{children}</div>;
    };

    const element = (
      <div>
        <Box>small lightblue box</Box>
      </div>
    );

    ReactDOM.render(element, document.getElementById('root'));
  </script>
</body>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-html",
          "metastring": "20:22",
          "20:22": true
        }}>{`<body>
  <div id="root"></div>
  <script src="https://unpkg.com/react@16.12.0/umd/react.development.js"></script>
  <script src="https://unpkg.com/react-dom@16.12.0/umd/react-dom.development.js"></script>
  <script src="https://unpkg.com/@babel/standalone@7.8.3/babel.js"></script>
  <style>
    .box {
      border: 1px solid #333;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }
    .box--large {
      width: 270px;
      height: 270px;
    }
  </style>
  <script type="text/babel">
    const Box = ({ children }) => {
      return <div className="box box--large">{children}</div>;
    };

    const element = (
      <div>
        <Box>small lightblue box</Box>
      </div>
    );

    ReactDOM.render(element, document.getElementById('root'));
  </script>
</body>
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`En utilisant du style inline`}</h1>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const Header = () => (
  <header style={{ marginTop: 20, fontSize: 17 }}>
    <div style={{ paddingLeft: 10 }}>
      <img src="/assets/logo.png" style={{ width: 100, height: 'auto' }} />
    </div>
  </header>
);
export default Header;
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`En utilisant des librairies de `}<strong parentName="h1">{`CSS-in-JS`}</strong></h1>
    <p>{`(Nous reviendrons dessus plus tard)`}</p>
    <FootNote mdxType="FootNote">
  📚{' '}
  <a href="https://2019.stateofcss.com/technologies/css-in-js/">
    State of CSS - 2019 Edition
  </a>
    </FootNote>
    <hr></hr>
    <h2>{`👨‍🔬 Nous allons réaliser un clone de Slack à partir d'`}<a parentName="h2" {...{
        "href": "https://github.com/greeeg/hetic-p2023-react/blob/master/resources/slack/index.html"
      }}>{`une intégration front`}</a></h2>
    <hr></hr>

    <img src={LegoBricks} style={{
      width: '60vw',
      height: 'auto'
    }} />
    <hr></hr>

    <div style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }}>
  <img style={{
        width: 'auto',
        height: '50vh',
        marginRight: 40
      }} src={LegoComponentsGood} alt="" />
  <img style={{
        width: 'auto',
        height: '50vh'
      }} src={LegoComponentsBad} alt="" />
    </div>
    <hr></hr>
    <h1>{`Construire une interface à partir de composants réutilisables`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Avoir de petites entités autonomes`}</li>
        <li parentName="ul">{`Les faire évoluer de maniere isolée`}</li>
        <li parentName="ul">{`Travailler plus efficacement à plusieurs`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`Gestion des évènements`}</h1>
    <hr></hr>
    <h2>{`De manière générale, on utilise le Javascript pour dynamiser des pages web :`}</h2>
    <ul>
      <li parentName="ul">{`Pour créer des interactions (Click, Keydown, etc)`}</li>
      <li parentName="ul">{`Pour créer des animations`}</li>
      <li parentName="ul">{`Et bien plus (AJAX, WebGL, Web APIs, etc.)`}</li>
    </ul>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On récupère l'élément sur lequel on souhaite greffer l'évenement\"",
          "subtitle": "\"On",
          "récupère": true,
          "l'élément": true,
          "sur": true,
          "lequel": true,
          "on": true,
          "souhaite": true,
          "greffer": true,
          "l'évenement\"": true
        }}>{`const input = document.querySelector('input');
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On ajoute un écouteur d'évenement sur cet élément\"",
          "subtitle": "\"On",
          "ajoute": true,
          "un": true,
          "écouteur": true,
          "d'évenement": true,
          "sur": true,
          "cet": true,
          "élément\"": true
        }}>{`const input = document.querySelector('input');

input.addEventListener('keyup', (e) => {});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On y ajoute la logique voulue\"",
          "subtitle": "\"On",
          "y": true,
          "ajoute": true,
          "la": true,
          "logique": true,
          "voulue\"": true
        }}>{`const input = document.querySelector('input');

input.addEventListener('keyup', (e) => {
  const text = e.target.value;

  if (text.length > 10) {
    alert('This is way too long');
  } else {
    document.title = \`(\${text}) Learning Javascript\`;
  }
});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const input = document.querySelector('input');

input.addEventListener('keyup', (e) => {
  const text = e.target.value;

  if (text.length > 10) {
    alert('This is way too long');
  } else {
    document.title = \`(\${text}) Learning Javascript\`;
  }
});
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On crée notre composant\"",
          "subtitle": "\"On",
          "crée": true,
          "notre": true,
          "composant\"": true
        }}>{`const TextInput = () => {
  return <input type="text" />;
};

const App = () => <TextInput />;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On ajoute un écouteur d'évènement sur l'élément du DOM qui nous intéresse\"",
          "subtitle": "\"On",
          "ajoute": true,
          "un": true,
          "écouteur": true,
          "d'évènement": true,
          "sur": true,
          "l'élément": true,
          "du": true,
          "DOM": true,
          "qui": true,
          "nous": true,
          "intéresse\"": true
        }}>{`const TextInput = () => {
  const onChange = () => {};

  return <input type="text" onKeyUp={onChange} />;
};

const App = () => <TextInput />;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On y ajoute la logique voulue\"",
          "subtitle": "\"On",
          "y": true,
          "ajoute": true,
          "la": true,
          "logique": true,
          "voulue\"": true
        }}>{`const TextInput = () => {
  const onChange = (e) => {
    const text = e.target.value;

    if (text.length > 10) {
      alert('This is way too long');
    } else {
      document.title = \`(\${text}) Learning Javascript\`;
    }
  };

  return <input type="text" onKeyUp={onChange} />;
};

const App = () => <TextInput />;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const TextInput = () => {
  const onChange = (e) => {
    const text = e.target.value;

    if (text.length > 10) {
      alert('This is way too long');
    } else {
      document.title = \`(\${text}) Learning Javascript\`;
    }
  };

  return <input type="text" onKeyUp={onChange} />;
};

const App = () => <TextInput />;
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Le state`}</h1>
    <hr></hr>
    <h3>{`Le state est similaire aux `}<strong parentName="h3">{`props`}</strong>{`. Il permet d'apporter une notion de dynamisme au composant.`}</h3>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Privé`}</li>
        <li parentName="ul">{`Contrôlé par le composant`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';

const Counter = () => {
  return <button>Clicked: 0</button>;
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';

const Counter = () => {
  return <button onClick={() => console.log('clicked')}>Clicked: 0</button>;
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState } from 'react';

const Counter = () => {
  const [count, setCount] = useState(0);

  return <button onClick={() => console.log('clicked')}>Clicked: 0</button>;
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState } from 'react';

const Counter = () => {
  const [count, setCount] = useState(0);

  return <button onClick={() => setCount(count + 1)}>Clicked: {count}</button>;
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState } from 'react';

const Counter = () => {
  const [count, setCount] = useState(0);

  return <button onClick={() => setCount(count + 1)}>Clicked: {count}</button>;
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`🤔`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Pourquoi ne pas utiliser simplement une variable ?`}</li>
        <li parentName="ul">{`Qu'est-ce que veut dire `}<strong parentName="li">{`useState`}</strong>{` ?`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2><strong parentName="h2">{`useState`}</strong>{` est un mécanisme propre à React qui permet de :`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Affecter une nouvelle valeur à la variable`}</li>
        <li parentName="ul">{`Prévenir React de ce changement`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`On appelle cela un `}<strong parentName="h1">{`hook`}</strong></h1>
    <p>{`Les hooks ont été introduit dans React à partir de la version `}<strong parentName="p">{`16.8`}</strong>{`. Ils permettent d'utiliser des fonctionnalités de React sans écrire de `}<strong parentName="p">{`Class`}</strong>{`.`}</p>
    <FootNote mdxType="FootNote">
  📚{' '}
  <a href="https://medium.com/better-programming/react-hooks-vs-classes-add2676a32f2">
    React: Hooks vs Classes?
  </a>
    </FootNote>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Un composant Counter écrit avec un hook ressemble à cela\"",
          "subtitle": "\"Un",
          "composant": true,
          "Counter": true,
          "écrit": true,
          "avec": true,
          "un": true,
          "hook": true,
          "ressemble": true,
          "à": true,
          "cela\"": true
        }}>{`import React, { useState } from 'react';

const Counter = () => {
  const [count, setCount] = useState(0);

  return <button onClick={() => setCount(count + 1)}>Clicked: {count}</button>;
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Mais on peut aussi l'écrire de cette manière\"",
          "subtitle": "\"Mais",
          "on": true,
          "peut": true,
          "aussi": true,
          "l'écrire": true,
          "de": true,
          "cette": true,
          "manière\"": true
        }}>{`import React, { Component } from 'react';

class Counter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      count: 0
    };
  }

  render() {
    return (
      <button onClick={() => this.setState({ count: this.state.count + 1 })}>
        Clicked: {count}
      </button>
    );
  }
}
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`👨‍🔬 Nous allons réaliser une interface de Threads à partir d'`}<a parentName="h2" {...{
        "href": "https://github.com/greeeg/hetic-p2023-react/blob/master/resources/threads/index.html"
      }}>{`une intégration front`}</a></h2>
    <hr></hr>
    <h1>{`Le cycle de vie des composants`}</h1>
    <hr></hr>
    <h2>{`Un composant React.js peut être mis à jour :`}</h2>
    <Steps mdxType="Steps">
      <ol>
        <li parentName="ol">{`lorsqu'une de ses `}<strong parentName="li">{`props`}</strong>{` change`}</li>
        <li parentName="ol">{`lorsque son `}<strong parentName="li">{`state`}</strong>{` change`}</li>
      </ol>
    </Steps>
    <hr></hr>
    <h2>{`On peut greffer un `}<strong parentName="h2">{`side-effect`}</strong>{` à ces changements en utilisant le hook `}<strong parentName="h2">{`useEffect`}</strong></h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState } from 'react';

const Counter = () => {
  const [count, setCount] = useState(0);

  return <button onClick={() => setCount(count + 1)}>Clicked: {count}</button>;
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState, useEffect } from 'react';

const Counter = () => {
  const [count, setCount] = useState(0);

  // Called each time component updates
  // and on initialization
  useEffect(() => {
    document.title = \`You clicked \${count} times\`;
  });

  return <button onClick={() => setCount(count + 1)}>Clicked: {count}</button>;
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`On peut préciser une dépendance au `}<strong parentName="h1">{`useEffect`}</strong></h1>
    <p>{`De cette manière, la fonction qu'il contient ne sera appelée que lorsque l'une de ces dépendances change`}</p>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState } from 'react';

const Counter = () => {
  const [integers, setIntegers] = useState(0);
  const [decimals, setDecimals] = useState(0);

  return (
    <div>
      <button onClick={() => setIntegers(integers + 1)}>Add integers</button>
      <button onClick={() => setDecimals(decimals + 1)}>Add decimals</button>

      <p>
        {integers},{decimals}
      </p>
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState, useEffect } from 'react';

const Counter = () => {
  const [integers, setIntegers] = useState(0);
  const [decimals, setDecimals] = useState(0);

  useEffect(() => {
    console.log('counter updated');
  });

  return (
    <div>
      <button onClick={() => setIntegers(integers + 1)}>Add integers</button>
      <button onClick={() => setDecimals(decimals + 1)}>Add decimals</button>

      <p>
        {integers},{decimals}
      </p>
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState, useEffect } from 'react';

const Counter = () => {
  const [integers, setIntegers] = useState(0);
  const [decimals, setDecimals] = useState(0);

  useEffect(() => {
    console.log('integers updated');
  }, [integers]);

  return (
    <div>
      <button onClick={() => setIntegers(integers + 1)}>Add integers</button>
      <button onClick={() => setDecimals(decimals + 1)}>Add decimals</button>

      <p>
        {integers},{decimals}
      </p>
    </div>
  );
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`On peut également préciser une fonction dite de `}<strong parentName="h2">{`cleanup`}</strong>{` à appeler lorsque le composant est démonté`}</h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState, useEffect } from 'react';

const Counter = () => {
  const [integers, setIntegers] = useState(0);
  const [decimals, setDecimals] = useState(0);

  useEffect(() => {
    console.log('integers updated');
  }, [integers]);

  return (
    <div>
      <button onClick={() => setIntegers(integers + 1)}>Add integers</button>
      <button onClick={() => setDecimals(decimals + 1)}>Add decimals</button>

      <p>
        {integers},{decimals}
      </p>
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState, useEffect } from 'react';

const Counter = () => {
  const [integers, setIntegers] = useState(0);
  const [decimals, setDecimals] = useState(0);

  useEffect(() => {
    console.log('counter mounted');

    return () => {
      console.log('counter unmounted');
    };
  }, []);

  return (
    <div>
      <button onClick={() => setIntegers(integers + 1)}>Add integers</button>
      <button onClick={() => setDecimals(decimals + 1)}>Add decimals</button>

      <p>
        {integers},{decimals}
      </p>
    </div>
  );
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Quelques règles liées aux hooks`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Only Call Hooks `}<strong parentName="li">{`at the Top Level`}</strong></li>
        <li parentName="ul">{`Only Call Hooks `}<strong parentName="li">{`from React Functions`}</strong></li>
      </ul>
    </Steps>
    <hr></hr>
    <h1>{`Le rendu conditionnel`}</h1>
    <hr></hr>
    <h2>{`Il permet de rendre un composant que si certaines conditions sont respectées`}</h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const FormInput = () => {
  return (
    <div>
      <input type="text" placeholder="Name" />
      <p>Please fill your name</p>
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const FormInput = () => {
  const containsError = true;
  return (
    <div>
      <input type="text" placeholder="Name" />
      {containsError && <p>Please fill your name</p>}
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const FormInput = () => {
  const containsError = true;
  return (
    <div>
      <input type="text" placeholder="Name" />
      {containsError && <p>Please fill your name</p>}
    </div>
  );
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Les listes`}</h1>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const numbers = [1, 2, 3, 4, 5];
const doubled = numbers.map((number) => number * 2);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const numbers = [1, 2, 3, 4, 5];
const doubled = numbers.map((number) => number * 2);

// [2, 4, 6, 8, 10]
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`const numbers = [1, 2, 3, 4, 5];
const doubled = numbers.map((number) => number * 2);

// [2, 4, 6, 8, 10]

const NamesList = () => {
  const names = ['Robert', 'Gérard', 'Michel'];
  return (
    <ul>
      {names.map((name, index) => {
        return <li key={index}>{name}</li>;
      })}
    </ul>
  );
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Les champs de formulaire`}</h1>
    <hr></hr>
    <h1>{`Controlled component`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Certains éléments du DOM maintiennent leur état dans une de leur propriété`}</li>
        <li parentName="ul">{`C'est le cas des `}<strong parentName="li">{`Input`}</strong>{` dans la propriété `}<strong parentName="li">{`value`}</strong></li>
        <li parentName="ul">{`On parle de `}<strong parentName="li">{`controlled component`}</strong>{` lorsque leur valeur est maintenue dans le state`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';

const TextInput = () => {
  const value = 'Greg';

  return <input type="text" value={value} />;
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState } from 'react';

const TextInput = () => {
  const [value, setValue] = useState('Greg');

  return (
    <input
      type="text"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h1>{`Avantages/Inconvénients de React.js`}</h1>
    <hr></hr>
    <h2>{`Avantages`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Approche orientée composant`}</li>
        <li parentName="ul">{`Écosystème/Communauté`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Inconvénients`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Slow startup time`}</li>
        <li parentName="ul">{`Bundle Size`}</li>
        <li parentName="ul">{`SEO`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Alternatives`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Vue.js`}</li>
        <li parentName="ul">{`Preact`}</li>
        <li parentName="ul">{`Angular`}</li>
        <li parentName="ul">{`Svelte.js`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Aller plus loin avec React.js`}</h2>
    <Link step={102} mdxType="Link">create-react-app</Link>
    <Link step={112} mdxType="Link">React Dev Tools</Link>
    <Link step={117} mdxType="Link">Déployer une app React.js</Link>
    <hr></hr>
    <Link step={130} mdxType="Link">L'AJAX avec React.js</Link>
    <Link step={138} mdxType="Link">Le routing</Link>
    <Link step={145} mdxType="Link">Le CSS-in-JS</Link>
    <Link step={154} mdxType="Link">Les performances</Link>
    <hr></hr>
    <h2><inlineCode parentName="h2">{`create-react-app`}</inlineCode></h2>
    <hr></hr>
    <p><inlineCode parentName="p">{`create-react-app`}</inlineCode>{` est un outil permettant de créer et maintenir des applications React.js facilement. Il prend la forme d'un `}<strong parentName="p">{`CLI`}</strong>{` (Command line interface) qui génère une structure de dossiers d'application React.js.`}</p>
    <hr></hr>
    <h2>{`Avantages`}</h2>
    <ul>
      <li parentName="ul">{`Pas de configuration initiale`}</li>
      <li parentName="ul">{`Plein d'éléments intégrés par défaut (Webpack, Dev server, Babel)`}</li>
      <li parentName="ul">{`Maintenu par la communauté React.js`}</li>
    </ul>
    <hr></hr>
    <h2>{`Inconvénients`}</h2>
    <ul>
      <li parentName="ul">{`Difficle à personnaliser pour des cas particuliers`}</li>
      <li parentName="ul">{`Une fois qu'on `}<strong parentName="li">{`eject`}</strong>{`, impossible de revenir en arrière`}</li>
    </ul>
    <hr></hr>
    <h2>{`Prérequis`}</h2>
    <ul>
      <li parentName="ul">{`Node.js (>8.10)`}</li>
      <li parentName="ul">{`NPM (>5.2) ou Yarn (>0.25)`}</li>
    </ul>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`# Générer une app avec NPM
npm init react-app app-name

# Générer une app avec Yarn
yarn create react-app app-name

# Se déplacer dans le dossier racine de mon app
cd app-name
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-json"
        }}>{`{
  "scripts": {
    "start": "react-scripts start",
    "build": "react-scripts build",
    "test": "react-scripts test",
    "eject": "react-scripts eject"
  }
}
`}</code></pre>
    </CodeSurfer>
    <FootNote mdxType="FootNote">
  Le package{' '}
  <a href="https://www.npmjs.com/package/react-scripts" target="_blank">
    react-scripts
  </a>{' '}
  contient toute la logique que nous aurions du mettre en place manuellement
  avec Webpack.
    </FootNote>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`app-name
├── README.md
├── node_modules
├── package.json
├── .gitignore
├── public
│   ├── favicon.ico
│   ├── index.html
│   ├── logo192.png
│   ├── logo512.png
│   ├── manifest.json
│   └── robots.txt
└── src
    ├── App.css
    ├── App.js
    ├── App.test.js
    ├── index.css
    ├── index.js
    ├── logo.svg
    └── serviceWorker.js
`}</code></pre>
    </CodeSurfer>
    <FootNote mdxType="FootNote">
  Le point d'entrée de l'application est le fichier{' '}
  <strong>src/index.js</strong>.
    </FootNote>
    <hr></hr>

    <img src={CreateReactApp} style={{
      width: 'auto',
      height: '65vh'
    }} />
    <FootNote mdxType="FootNote">
  En utilisant la commande <strong>yarn start</strong>, cette page devrait
  s'afficher dans votre navigateur.
    </FootNote>
    <hr></hr>
    <h2>{`Vous êtes prêts à travailler, happy coding 🤗.`}</h2>
    <hr></hr>
    <h2>{`React Dev Tools`}</h2>
    <hr></hr>
    <h3>{`Une extension navigateur pour debugger des applications React.js`}</h3>
    <hr></hr>

    <img src={ReactDevTools} style={{
      width: 'auto',
      height: '70vh'
    }} />
    <FootNote mdxType="FootNote">
  Disponible sur{' '}
  <a href="https://chrome.google.com/webstore/detail/react-developer-tools/fmkadmapgofadopljbjfkapdkoienihi" target="_blank">
    Chrome
  </a>{' '}
  et{' '}
  <a href="https://addons.mozilla.org/en-US/firefox/addon/react-devtools/" target="_blank">
    Firefox
  </a>
    </FootNote>
    <hr></hr>

    <img src={ReactDevToolsComponentsTree} style={{
      width: 'auto',
      height: '70vh'
    }} />
    <hr></hr>

    <img src={ReactDevToolsFlamegraph} style={{
      width: 'auto',
      height: '70vh'
    }} />
    <FootNote mdxType="FootNote">
  📚{' '}
  <a href="https://reactjs.org/blog/2018/09/10/introducing-the-react-profiler.html" target="_blank">
    Introducing the React Profiler
  </a>
    </FootNote>
    <hr></hr>
    <h2>{`Déployer une application React.js`}</h2>
    <hr></hr>
    <h3><inlineCode parentName="h3">{`create-react-app`}</inlineCode>{` est en mesure de générer pour vous un export statique de votre application web avec la commande `}<strong parentName="h3">{`yarn build`}</strong>{`.`}</h3>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`app-name
└── build
    ├── asset-manifest.json
    ├── favicon.ico
    ├── index.html
    ├── logo192.png
    ├── logo512.png
    ├── manifest.json
    ├── precache-manifest.a3de7dc90081be00fbc342ae7cc26178.js
    ├── robots.txt
    ├── service-worker.js
    └── static

`}</code></pre>
    </CodeSurfer>
    <FootNote mdxType="FootNote">
  L'export statique se trouve dans le dossier <strong>build</strong> de votre
  projet.
    </FootNote>
    <hr></hr>
    <h2>{`Il existe 2 grands moyens de déployer une application web pour la rendre accessible :`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Utiliser un serveur web avec `}<a parentName="li" {...{
            "href": "https://social.hoga.fr/system/media_attachments/files/000/000/494/original/c3fde188f35aa92d.png"
          }}>{`FTP`}</a>{` par exemple`}</li>
        <li parentName="ul">{`Utiliser un CDN/PaaS`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Nous allons utiliser `}<a parentName="h2" {...{
        "href": "https://www.netlify.com/"
      }}>{`Netlify`}</a></h2>
    <hr></hr>
    <h2>{`Netlify est une plateforme cloud permettant le déploiement "simple" d'applications web statiques.`}</h2>
    <hr></hr>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Plan gratuit très généreux (100GB/mois)`}</li>
        <li parentName="ul">{`Intégrations GitHub/BitBucket/Gitlab`}</li>
        <li parentName="ul">{`Continuous deployment`}</li>
        <li parentName="ul">{`Autres fonctionnalités intéressantes (Lambda functions, Forms, Auth, etc.)`}</li>
      </ul>
    </Steps>
    <hr></hr>

    <img src={Netlify00} style={{
      width: 'auto',
      height: '75vh'
    }} />
    <hr></hr>

    <img src={Netlify01} style={{
      width: 'auto',
      height: '70vh'
    }} />
    <FootNote mdxType="FootNote">
  Étape 1 : Créer un site à partir d'un dossier statique ou un repository Git
    </FootNote>
    <hr></hr>

    <img src={Netlify02} style={{
      width: 'auto',
      height: '75vh'
    }} />
    <FootNote mdxType="FootNote">Étape 2 : Avec Git, il faut effectuer une connexion OAuth</FootNote>
    <hr></hr>

    <img src={Netlify03} style={{
      width: 'auto',
      height: '75vh'
    }} />
    <FootNote mdxType="FootNote">Étape 3 : Sélectionner son repository</FootNote>
    <hr></hr>

    <img src={Netlify04} style={{
      width: 'auto',
      height: '75vh'
    }} />
    <FootNote mdxType="FootNote">
  Étape 4 : Définir le contexte de <strong>build</strong>
    </FootNote>
    <hr></hr>

    <img src={Netlify05} style={{
      width: 'auto',
      height: '75vh'
    }} />
    <FootNote mdxType="FootNote">Étape 5 : Votre site est disponible à l'URL indiquée</FootNote>
    <hr></hr>
    <h2>{`L'AJAX avec React.js`}</h2>
    <hr></hr>
    <h2><strong parentName="h2">{`Asynchronous JavaScript and XML`}</strong></h2>
    <hr></hr>
    <h2>{`L'AJAX permet a des interfaces web d'effectuer des actions asynchrones sans pour autant recharger la page du navigateur.`}</h2>
    <hr></hr>
    <h4>{`Les applications React.js mettent à jour l'interface utilisateur sans jamais recharger la page du navigateur. AJAX est donc la seule manière de mettre à jour notre interface pour :`}</h4>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Charger des données depuis une API (Profil utilisateur, etc.)`}</li>
        <li parentName="ul">{`Envoyer des donnés à une API (Formulaire, Analytics, etc.)`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Nous souhaitons afficher la liste des posts exposés par cette API\"",
          "subtitle": "\"Nous",
          "souhaitons": true,
          "afficher": true,
          "la": true,
          "liste": true,
          "des": true,
          "posts": true,
          "exposés": true,
          "par": true,
          "cette": true,
          "API\"": true
        }}>{`const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Avec Fetch, on effectue une requête AJAX à cette URL\"",
          "subtitle": "\"Avec",
          "Fetch,": true,
          "on": true,
          "effectue": true,
          "une": true,
          "requête": true,
          "AJAX": true,
          "à": true,
          "cette": true,
          "URL\"": true
        }}>{`const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';

fetch(API_ENDPOINT);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Comme cette instruction est asynchrone, on utilise 'then' pour effectuer une opération lorsque l'on récupère le résultat\"",
          "subtitle": "\"Comme",
          "cette": true,
          "instruction": true,
          "est": true,
          "asynchrone,": true,
          "on": true,
          "utilise": true,
          "'then'": true,
          "pour": true,
          "effectuer": true,
          "une": true,
          "opération": true,
          "lorsque": true,
          "l'on": true,
          "récupère": true,
          "le": true,
          "résultat\"": true
        }}>{`const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';

fetch(API_ENDPOINT).then((response) => {
  console.log(response);
});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On peut chaîner plusieurs 'then', notamment pour utiliser la réponse au format JSON\"",
          "subtitle": "\"On",
          "peut": true,
          "chaîner": true,
          "plusieurs": true,
          "'then',": true,
          "notamment": true,
          "pour": true,
          "utiliser": true,
          "la": true,
          "réponse": true,
          "au": true,
          "format": true,
          "JSON\"": true
        }}>{`const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';

fetch(API_ENDPOINT)
  .then((response) => {
    return response.json();
  })
  .then((json) => {
    console.log(json);
  });
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`Et avec React.js ?`}</h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Nous souhaitons afficher la liste des posts dans l'App\"",
          "subtitle": "\"Nous",
          "souhaitons": true,
          "afficher": true,
          "la": true,
          "liste": true,
          "des": true,
          "posts": true,
          "dans": true,
          "l'App\"": true
        }}>{`import React from 'react';

const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';

const App = () => {
  return (
    <div>
      <h1>The New Yorker</h1>

      <ul>
        <li>Breaking News: 1</li>
        <li>Breaking News: 2</li>
      </ul>
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On ne doit charger les posts qu'à l'initialisation du composant\"",
          "subtitle": "\"On",
          "ne": true,
          "doit": true,
          "charger": true,
          "les": true,
          "posts": true,
          "qu'à": true,
          "l'initialisation": true,
          "du": true,
          "composant\"": true
        }}>{`import React, { useEffect } from 'react';

const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';

const App = () => {
  useEffect(() => {
    console.log('Hello, I just wake up!');
  }, []);

  return (
    <div>
      <h1>The New Yorker</h1>

      <ul>
        <li>Breaking News: 1</li>
        <li>Breaking News: 2</li>
      </ul>
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Une fois chargés, il faut trouver un moyen de les stocker et d'y accéder dans le JSX\"",
          "subtitle": "\"Une",
          "fois": true,
          "chargés,": true,
          "il": true,
          "faut": true,
          "trouver": true,
          "un": true,
          "moyen": true,
          "de": true,
          "les": true,
          "stocker": true,
          "et": true,
          "d'y": true,
          "accéder": true,
          "dans": true,
          "le": true,
          "JSX\"": true
        }}>{`import React, { useEffect } from 'react';

const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';

const App = () => {
  useEffect(() => {
    fetch(API_ENDPOINT)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log('Posts are back from the API!', json);
      });
  }, []);

  return (
    <div>
      <h1>The New Yorker</h1>

      <ul>
        <li>Breaking News: 1</li>
        <li>Breaking News: 2</li>
      </ul>
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"On peut utiliser le hook 'useState' pour le faire\"",
          "subtitle": "\"On",
          "peut": true,
          "utiliser": true,
          "le": true,
          "hook": true,
          "'useState'": true,
          "pour": true,
          "faire\"": true
        }}>{`import React, { useEffect, useState } from 'react';

const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';

const App = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch(API_ENDPOINT)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        setPosts(json);
      });
  }, []);

  return (
    <div>
      <h1>The New Yorker</h1>

      <ul>
        <li>Breaking News: 1</li>
        <li>Breaking News: 2</li>
      </ul>
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Et ensuite boucler à travers les posts dans le JSX pour les afficher\"",
          "subtitle": "\"Et",
          "ensuite": true,
          "boucler": true,
          "à": true,
          "travers": true,
          "les": true,
          "posts": true,
          "dans": true,
          "le": true,
          "JSX": true,
          "pour": true,
          "afficher\"": true
        }}>{`import React, { useEffect, useState } from 'react';

const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/posts';

const App = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch(API_ENDPOINT)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        setPosts(json);
      });
  }, []);

  return (
    <div>
      <h1>The New Yorker</h1>

      <ul>
        {posts.map((post) => (
          <li key={post.id}>{post.title}</li>
        ))}
      </ul>
    </div>
  );
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`👨‍🔬 Nous allons réaliser une application permettant de découvrir des articles Wikipedia`}</h2>
    <hr></hr>
    <h2>{`Le routing`}</h2>
    <hr></hr>
    <h2>{`De manière générale, le routing est le processus qui fait correspondre un chemin à une ressource.`}</h2>
    <hr></hr>
    <h3>{`En déployant un site web composé de pages HTML statiques, vous laissez le serveur web s'occuper de faire correspondre une URL au fichier correspondant.`}</h3>
    <h3>{`L'URL `}<strong parentName="h3">{`/`}</strong>{` affiche le fichier `}<strong parentName="h3">{`index.html`}</strong></h3>
    <hr></hr>
    <h3>{`Avec React.js, peu importe le chemin demandé, on charge toujours le fichier `}<strong parentName="h3">{`index.html`}</strong>{`. C'est un package Javascript qui se chargera d'afficher les composants associés à la page demandée.`}</h3>
    <hr></hr>
    <h2>{`Il existe plusieurs solutions de routing avec React.js`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/ReactTraining/react-router"
          }}>{`React router`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/reach/router"
          }}>{`Reach router`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/router5/router5"
          }}>{`Router 5`}</a></li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Nous allons utiliser `}<a parentName="h2" {...{
        "href": "https://reacttraining.com/react-router/web/guides/quick-start"
      }}>{`React router`}</a></h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';
import { render } from 'react-dom';

const App = () => {
  return <div>Hello from my App</div>;
};

ReactDOM.render(<App />, document.getElementById('root'));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/">
          <div>Hello from my App</div>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/about">
          <div>Hello from About page</div>
        </Route>
        <Route path="/">
          <div>Hello from Home page</div>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Switch, Route, Link } from 'react-router-dom';

const App = () => {
  return (
    <BrowserRouter>
      <header>
        <Link to="/">Homepage</Link>
        <Link to="/about">About</Link>
      </header>

      <Switch>
        <Route path="/about">
          <div>Hello from About page</div>
        </Route>
        <Route path="/">
          <div>Hello from Home page</div>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Switch, Route, Link } from 'react-router-dom';

const Home = () => <div>Hello from Home page</div>;
const About = () => <div>Hello from About page</div>;

const App = () => {
  return (
    <BrowserRouter>
      <header>
        <Link to="/">Homepage</Link>
        <Link to="/about">About</Link>
      </header>

      <Switch>
        <Route path="/about" component={About} />
        <Route path="/" component={Home} />
      </Switch>
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';
import { render } from 'react-dom';
import { useParams } from 'react-router';
import { BrowserRouter, Switch, Route, Link } from 'react-router-dom';

const Home = () => <div>Hello from Home page</div>;
const About = () => <div>Hello from About page</div>;
const BlogPost = () => {
  const { postId } = useParams();
  return <div>Post: {postId}</div>;
};

const App = () => {
  return (
    <BrowserRouter>
      <header>
        <Link to="/">Homepage</Link>
        <Link to="/about">About</Link>
      </header>

      <Switch>
        <Route path="/blog/:postId" component={BlogPost} />
        <Route path="/about" component={About} />
        <Route path="/" component={Home} />
      </Switch>
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`Le CSS-in-JS`}</h2>
    <hr></hr>
    <h2>{`Le CSS-in-JS est une méthodologie visant à écrire son style au sein de fichiers Javascript.`}</h2>
    <hr></hr>
    <h2>{`Elle a été démocratisée avec le développement d'interfaces utilisateurs orientées composants.`}</h2>
    <FootNote mdxType="FootNote">
  📚{' '}
  <a href="https://www.youtube.com/watch?v=bIK2NwoK9xk&feature=youtu.be&t=114">
    Max Stoiber - The Component Age & Styling React Applications
  </a>
    </FootNote>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Cette implémentation n'a de sens que lorsque l'on travaille à l'échelle de pages liées à des feuilles de style\"",
          "subtitle": "\"Cette",
          "implémentation": true,
          "n'a": true,
          "de": true,
          "sens": true,
          "que": true,
          "lorsque": true,
          "l'on": true,
          "travaille": true,
          "à": true,
          "l'échelle": true,
          "pages": true,
          "liées": true,
          "des": true,
          "feuilles": true,
          "style\"": true
        }}>{`<Button className="btn"></Button>
<Button className="btn btn--primary"></Button>
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"À l'échelle d'un composant, on préfère encapsuler tout son fonctionnement en un fichier\"",
          "subtitle": "\"À",
          "l'échelle": true,
          "d'un": true,
          "composant,": true,
          "on": true,
          "préfère": true,
          "encapsuler": true,
          "tout": true,
          "son": true,
          "fonctionnement": true,
          "en": true,
          "un": true,
          "fichier\"": true
        }}>{`<Button></Button>
<Button primary></Button>
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`If you're using React, you have access to a more powerful styling construct than CSS class names. You have components.`}</h2>
    <h4>{`-Michael Chan`}</h4>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`<App>
  <Header variation="dark">
    <Navigation>
      <Link active to="/about">
        About us
      </Link>
      <Link to="/contact">Contact</Link>
    </Navigation>
  </Header>
</App>
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`Il existe des dizaines de solutions de CSS-in-JS avec React.js`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/styled-components/styled-components"
          }}>{`Styled-components`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/zeit/styled-jsx"
          }}>{`Styled JSX`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/cssinjs/jss"
          }}>{`JSS`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/threepointone/glamor"
          }}>{`Glamor`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/emotion-js/emotion"
          }}>{`Emotion`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/Khan/aphrodite"
          }}>{`Aphrodite`}</a></li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Nous allons utiliser `}<a parentName="h2" {...{
        "href": "https://styled-components.com/docs"
      }}>{`Styled-components`}</a></h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import styled from 'styled-components';
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import styled from 'styled-components';

const Button = styled.button\`
  color: palevioletred;
  background-color: papayawhip;
  padding: 1em;
\`;
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import styled from 'styled-components';

const Button = styled.button\`
  color: palevioletred;
  background-color: papayawhip;
  padding: 1em;
\`;

const App = () => (
  <div>
    <Button>Click me</Button>
  </div>
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import styled from 'styled-components';

const Button = styled.button\`
  color: palevioletred;
  background-color: papayawhip;
  padding: \${(props) => (props.primary ? 2 : 1)}em;
\`;

const App = () => (
  <div>
    <Button>Click me</Button>
    <Button primary>Click me</Button>
  </div>
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import styled from 'styled-components';

const Button = styled.button\`
  color: palevioletred;
  background-color: papayawhip;
  padding: \${(props) => (props.primary ? 2 : 1)}em;

  span {
    color: red;
  }
\`;

const App = () => (
  <div>
    <Button>
      <span>I'm a red span inside a Button</span>
    </Button>
    <Button primary>Click me</Button>
  </div>
);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import styled from 'styled-components';

const Button = styled.button\`
  color: palevioletred;
  background-color: papayawhip;
  padding: \${(props) => (props.primary ? 2 : 1)}em;

  span {
    color: red;
  }
\`;

const SmallButton = styled(Button)\`
  font-size: 12px;
\`;

const App = () => (
  <div>
    <SmallButton>
      <span>I'm a red span inside a Button</span>
    </SmallButton>
    <Button primary>Click me</Button>
  </div>
);
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`Les performances`}</h2>
    <hr></hr>
    <h2>{`React is `}<strong parentName="h2">{`slow`}</strong></h2>
    <hr></hr>
    <img src="https://media.giphy.com/media/3s6IlivlQZQ5xtFcO2/giphy.gif" style={{
      width: 'auto',
      height: '60vh'
    }} />
    <hr></hr>
    <h2>{`Toute application Javascript mal conçue peut avoir tendance à perdre en performances.`}</h2>
    <p>{`Il s'agit alors de connaître les limites de son fonctionnement et les actions possibles pour en améliorer les performances.`}</p>
    <hr></hr>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Utiliser des dépendances sans en comprendre l'impact`}</li>
        <li parentName="ul">{`Afficher des listes importantes de données`}</li>
        <li parentName="ul">{`Build son application en un seul bundle Javascript`}</li>
        <li parentName="ul">{`Re-calculer des choses inutilement`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Utiliser des dépendances sans en comprendre l'impact`}</h2>
    <hr></hr>
    <h3>{`Il est difficile de comprendre l'impact d'une librairie sur les performances d'une application. Sans aucun contrôle ni mesure, on peut rapidement dégrader l'expérience utilisateur de son site web.`}</h3>
    <hr></hr>
    <h2>{`Un bon outil pour ça : `}<a parentName="h2" {...{
        "href": "https://bundlephobia.com/"
      }}>{`Bundlephobia`}</a></h2>
    <hr></hr>
    <h2>{`Afficher des listes importantes de données`}</h2>
    <hr></hr>
    <h3>{`Il peut être intéressant de virtualiser des listes importantes de données pour en améliorer les performances. On utilise des packages tels que `}<a parentName="h3" {...{
        "href": "https://github.com/bvaughn/react-window"
      }}>{`react-window`}</a>{` ou `}<a parentName="h3" {...{
        "href": "https://github.com/bvaughn/react-virtualized"
      }}>{`react-virtualized`}</a>{`.`}</h3>
    <hr></hr>
    <h2>{`Build son application en un seul bundle Javascript`}</h2>
    <hr></hr>
    <h3>{`Par défaut, avec `}<inlineCode parentName="h3">{`create-react-app`}</inlineCode>{`, si vous utilisez la commande `}<inlineCode parentName="h3">{`yarn build`}</inlineCode>{`, un seul fichier JS main est généré. Il contient tous vos composants.`}</h3>
    <hr></hr>
    <h2>{`Si certains de vos composants utilisent de grosses dépendances, il peut être pertinent d'en générer un fichier séparé qui ne sera chargé qu'au moment voulu.`}</h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Imaginons un composant ThreeScene qui affiche un rendu 3D dans mon application\"",
          "subtitle": "\"Imaginons",
          "un": true,
          "composant": true,
          "ThreeScene": true,
          "qui": true,
          "affiche": true,
          "rendu": true,
          "3D": true,
          "dans": true,
          "mon": true,
          "application\"": true
        }}>{`import React from 'react';
import * as THREE from 'three';

export const ThreeScene = () => {
  useEffect(() => {
    const scene = new THREE.Scene();
    // ...
  }, []);

  return <div id="scene" />;
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "subtitle=\"Avec React.lazy, on indique à React que le chargement de ce composant n'est pas essentiel et peut être retardé. Un fichier JS à part sera donc généré et chargé en temps voulu.\"",
          "subtitle": "\"Avec",
          "React.lazy,": true,
          "on": true,
          "indique": true,
          "à": true,
          "React": true,
          "que": true,
          "le": true,
          "chargement": true,
          "de": true,
          "ce": true,
          "composant": true,
          "n'est": true,
          "pas": true,
          "essentiel": true,
          "et": true,
          "peut": true,
          "être": true,
          "retardé.": true,
          "Un": true,
          "fichier": true,
          "JS": true,
          "part": true,
          "sera": true,
          "donc": true,
          "généré": true,
          "chargé": true,
          "en": true,
          "temps": true,
          "voulu.\"": true
        }}>{`import React, { Suspense } from 'react';

const ThreeScene = React.lazy(() => import('./ThreeScene'));

const App = () => {
  return (
    <div>
      <header>App Name</header>

      <Suspense fallback={<div>Loading 3D Scene...</div>}>
        <ThreeScene />
      </Suspense>
    </div>
  );
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`Éviter de re-calculer des choses inutilement`}</h2>
    <hr></hr>
    <CodeSurfer theme={nightOwl} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState } from 'react';

const CheckoutButton = ({ cart }) => {
  let total = 0;
  cart.products.forEach((product) => {
    total += product.price * product.count;
  });

  return <button>Buy for \${total}</button>;
};

const App = () => {
  const [cart, setCart] = useState({
    color: 'blue',
    products: [
      {
        name: 'Large T Shirt',
        price: 12.9,
        count: 1
      },
      {
        name: 'Hoodie',
        price: 50.8,
        count: 2
      }
    ]
  });

  return (
    <div>
      <CheckoutButton cart={cart} />
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState } from 'react';

const CheckoutButton = ({ cart }) => {
  let total = 0;
  cart.products.forEach((product) => {
    total += product.price * product.count;
  });

  return <button>Buy for \${total}</button>;
};

const App = () => {
  const [cart, setCart] = useState({
    color: 'blue',
    products: [
      {
        name: 'Large T Shirt',
        price: 12.9,
        count: 1
      },
      {
        name: 'Hoodie',
        price: 50.8,
        count: 2
      }
    ]
  });

  return (
    <div>
      <button
        onClick={() =>
          setCart({
            ...cart,
            color: 'purple'
          })
        }
      >
        Update color
      </button>
      <CheckoutButton cart={cart} />
    </div>
  );
};
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React, { useState, useMemo } from 'react';

const CheckoutButton = ({ total }) => {
  return <button>Buy for \${total}</button>;
};

const App = () => {
  const [cart, setCart] = useState({
    color: 'blue',
    products: [
      {
        name: 'Large T Shirt',
        price: 12.9,
        count: 1
      },
      {
        name: 'Hoodie',
        price: 50.8,
        count: 2
      }
    ]
  });

  const total = useMemo(() => {
    let t = 0;
    cart.products.forEach((product) => {
      t += product.price * product.count;
    });
    return t;
  }, [cart.products]);

  return (
    <div>
      <button
        onClick={() =>
          setCart({
            ...cart,
            color: 'purple'
          })
        }
      >
        Update color
      </button>
      <CheckoutButton total={total} />
    </div>
  );
};
`}</code></pre>
    </CodeSurfer>
    <hr></hr>
    <h2>{`Le hook `}<strong parentName="h2">{`useMemo`}</strong>{` permet de memoïser une valeur afin de ne la recalculer que si une de ses entrées change.`}</h2>
    <hr></hr>
    <h2>{`L'écosystème React`}</h2>
    <Link step={171} mdxType="Link">The React community</Link>
    <Link step={174} mdxType="Link">React.js developer roadmap</Link>
    <hr></hr>
    <h2>{`The React community`}</h2>
    <hr></hr>
    <h2>{`En plus de la `}<a parentName="h2" {...{
        "href": "https://fr.reactjs.org/community/team.html"
      }}>{`Core Team`}</a>{` qui travaille à plein temps sur React.js, il existe des `}<a parentName="h2" {...{
        "href": "https://twitter.com/dan_abramov/status/937339649537781762"
      }}>{`dizaines de personnes`}</a>{` actives dans la communauté à suivre.`}</h2>
    <hr></hr>
    <h2>{`En particulier`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://twitter.com/dan_abramov"
          }}>{`Dan Abramov`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://twitter.com/kentcdodds"
          }}>{`Kent C Dodds`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://twitter.com/mxstbr"
          }}>{`Max Stoiber`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://twitter.com/peggyrayzis"
          }}>{`Peggy Rayzis`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://twitter.com/wesbos"
          }}>{`Wes Bos`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://twitter.com/NikkitaFTW"
          }}>{`Sara Vieira`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://twitter.com/rauchg"
          }}>{`Guillermo Rauch`}</a></li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`React.js developer roadmap`}</h2>
    <hr></hr>
    <a href="https://github.com/adam-golab/react-developer-roadmap" target="_blank">
  <img src="https://github.com/adam-golab/react-developer-roadmap/raw/master/roadmap.png" style={{
        width: 'auto',
        height: '70vh'
      }} />
    </a>
    <hr></hr>
    <h2>{`Bonus 🤗`}</h2>
    <hr></hr>
    <h1>{`React Native`}</h1>
    <hr></hr>
    <h3>{`Build native mobile apps `}<strong parentName="h3">{`using JavaScript and React`}</strong></h3>
    <hr></hr>
    <h2>{`Native vs Hybrid vs Web App`}</h2>
    <hr></hr>
    <h2><strong parentName="h2">{`Native apps`}</strong></h2>
    <h3>{`Elles représentent la grande majorité des applications sur vos téléphones`}</h3>
    <hr></hr>
    <h2><strong parentName="h2">{`Avantages`}</strong></h2>
    <ul>
      <li parentName="ul">{`Performances`}</li>
      <li parentName="ul">{`Fonctionalités natives`}</li>
    </ul>
    <hr></hr>
    <h2><strong parentName="h2">{`Inconvénients`}</strong></h2>
    <ul>
      <li parentName="ul">{`Plusieurs codebases`}</li>
      <li parentName="ul">{`Nécessite plus de développeurs`}</li>
    </ul>
    <hr></hr>
    <h2><strong parentName="h2">{`Hybrid apps`}</strong></h2>
    <h3>{`Une application web encapsulée dans une application native`}</h3>
    <hr></hr>
    <h2><strong parentName="h2">{`Avantages`}</strong></h2>
    <ul>
      <li parentName="ul">{`Temps de développement`}</li>
      <li parentName="ul">{`HTML, CSS, JS`}</li>
    </ul>
    <hr></hr>
    <h2><strong parentName="h2">{`Inconvénients`}</strong></h2>
    <ul>
      <li parentName="ul">{`Performances`}</li>
      <li parentName="ul">{`Expérience utilisateur`}</li>
    </ul>
    <hr></hr>
    <h2><strong parentName="h2">{`Web apps (PWA)`}</strong></h2>
    <h3>{`Une application web avec des capacités mobiles`}</h3>
    <hr></hr>
    <h2><strong parentName="h2">{`Avantages`}</strong></h2>
    <ul>
      <li parentName="ul">{`Rien à installer`}</li>
      <li parentName="ul">{`Fonctionnalités natives`}</li>
      <li parentName="ul">{`Performances`}</li>
      <li parentName="ul">{`Temps de développement`}</li>
    </ul>
    <hr></hr>
    <h2><strong parentName="h2">{`Inconvénients`}</strong></h2>
    <ul>
      <li parentName="ul">{`Absent des stores`}</li>
      <li parentName="ul">{`Compatibilité limitée`}</li>
    </ul>
    <hr></hr>
    <h2>{`Et React Native au milieu de tout ça ?`}</h2>
    <hr></hr>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Faire du natif lorsque l'on vient du web`}</li>
        <li parentName="ul">{`1 codebase : 2 plateformes`}</li>
        <li parentName="ul">{`Aller vite`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`On essaye ?`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://reactnative.dev/docs/environment-setup"
      }}>{`reactnative.dev`}</a></h3>
    <hr></hr>
    <ul>
      <li parentName="ul">{`📣 Twitter: `}<a parentName="li" {...{
          "href": "https://twitter.com/greeeg"
        }}>{`@greeeg`}</a></li>
      <li parentName="ul">{`🔬 GitHub: `}<a parentName="li" {...{
          "href": "https://github.com/greeeg"
        }}>{`@greeeg`}</a></li>
      <li parentName="ul">{`✏️ Email: `}<a parentName="li" {...{
          "href": "mailto:hello@greeeg.com"
        }}>{`hello@greeeg.com`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;